// src/components/ContractsByTypeChart.js

import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';

// Colori casuali per le fette del grafico
const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#AF19FF', '#FF1919'];

/**
 * Componente per visualizzare un grafico a torta dei contratti per tipo.
 * @param {object} props - Le props del componente.
 * @param {Array<object>} props.data - L'array di dati. Ogni oggetto deve avere 'type' e 'count'.
 */
const ContractsByTypeChart = ({ data }) => {
    if (!data || data.length === 0) {
        return <p>Nessun dato disponibile per questo grafico.</p>;
    }

    return (
        <ResponsiveContainer width="100%" height="100%">
            <PieChart>
                <Pie
                    data={data}
                    cx="50%"
                    cy="50%"
                    labelLine={false}
                    outerRadius={80}
                    fill="#8884d8"
                    dataKey="count" // Il valore numerico per la dimensione della fetta
                    nameKey="type"  // Il nome della fetta
                    label={(entry) => `${entry.type}: ${entry.count}`} // Mostra etichetta e valore
                >
                    {data.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                </Pie>
                <Tooltip />
                <Legend />
            </PieChart>
        </ResponsiveContainer>
    );
};

export default ContractsByTypeChart;